import { render, staticRenderFns } from "./SpreadTable.vue?vue&type=template&id=efc03a9c&scoped=true&"
import script from "./SpreadTable.vue?vue&type=script&lang=js&"
export * from "./SpreadTable.vue?vue&type=script&lang=js&"
import style0 from "./SpreadTable.vue?vue&type=style&index=0&id=efc03a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc03a9c",
  null
  
)

export default component.exports